/**
 * DEV-258 — endereço do formulário da pessoa gestora no APP Consultor:
 * `/descricao-vaga/{tenant}/{formId}` (formato do AC-08 do DEV-268 com o host
 * do APP Consultor). Essas telas não usam Keycloak.
 *
 * O prefixo INTEIRO é público, inclusive caminho malformado (sem tenant,
 * `formId` que não é UUID): quem chega por um link quebrado vê a tela de erro
 * do formulário, nunca o login do consultor (Q13).
 */
export const ALIGNMENT_PATH_PREFIX = '/descricao-vaga';

const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export function isPublicAlignmentPath(pathname: string): boolean {
  return pathname === ALIGNMENT_PATH_PREFIX || pathname.startsWith(`${ALIGNMENT_PATH_PREFIX}/`);
}

/** O `formId` do link é sempre UUID; qualquer outra coisa é link quebrado. */
export function isAlignmentFormId(value: string): boolean {
  return UUID.test(value);
}
